import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { Tabs } from '../../components/ui/Tabs';
import { Button } from '../../components/ui/Button';
import { DataTable } from '../../components/ui/DataTable';
import { StatusPill } from '../../components/ui/StatusPill';
import { UserIcon, ShieldIcon, BellIcon, GlobeIcon, PlusIcon } from 'lucide-react';
const users = [{
  id: '1',
  name: 'James Lim',
  email: 'james.lim@oceanicharvest.sg',
  role: 'Supplier Admin',
  status: 'Active',
  lastLogin: 'Today, 09:41 AM'
}, {
  id: '2',
  name: 'Sarah Tan',
  email: 'sarah.tan@oceanicharvest.sg',
  role: 'AR Clerk',
  status: 'Active',
  lastLogin: 'Yesterday, 14:20 PM'
}, {
  id: '3',
  name: 'Michael Wong',
  email: 'michael.wong@oceanicharvest.sg',
  role: 'Sales Manager',
  status: 'Active',
  lastLogin: 'Mar 12, 2026'
}, {
  id: '4',
  name: 'Lisa Chen',
  email: 'lisa.chen@oceanicharvest.sg',
  role: 'Quality Lead',
  status: 'Pending',
  lastLogin: 'Never'
}];
export const UserSettingsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('profile');
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-1918">
      <PageHeader title="Settings" breadcrumbs={[{
      label: 'Home',
      href: '/supplier/dashboard'
    }, {
      label: 'Settings'
    }]} data-id="element-1919" />
      <Card noPadding data-id="element-1920">
        <div className="px-6 pt-4 border-b border-border-light" data-id="element-1921">
          <Tabs tabs={[{
          id: 'profile',
          label: 'My Profile'
        }, {
          id: 'users',
          label: 'Users & Roles'
        }, {
          id: 'notifications',
          label: 'Notifications'
        }, {
          id: 'security',
          label: 'Security'
        }, {
          id: 'preferences',
          label: 'Preferences'
        }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-1922" />
        </div>
        <div className="p-6" data-id="element-1923">
          {activeTab === 'profile' && <div className="max-w-2xl space-y-6" data-id="element-1924">
              <div className="flex items-center gap-4 mb-6" data-id="element-1925">
                <div className="w-16 h-16 bg-fpg-navy text-white rounded-full flex items-center justify-center text-2xl font-bold" data-id="element-1926">
                  JL
                </div>
                <div data-id="element-1927">
                  <h3 className="text-xl font-bold text-text-primary" data-id="element-1928">
                    James Lim
                  </h3>
                  <p className="text-text-secondary" data-id="element-1929">
                    Supplier Admin • Oceanic Harvest Pte Ltd
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1930">
                <div data-id="element-1931">
                  <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1932">
                    First Name
                  </label>
                  <input type="text" defaultValue="James" className="w-full p-2 border border-border-default rounded-fluent text-sm" data-id="element-1933" />
                </div>
                <div data-id="element-1934">
                  <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1935">
                    Last Name
                  </label>
                  <input type="text" defaultValue="Lim" className="w-full p-2 border border-border-default rounded-fluent text-sm" data-id="element-1936" />
                </div>
                <div className="col-span-2" data-id="element-1937">
                  <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1938">
                    Email Address
                  </label>
                  <input type="email" defaultValue="james.lim@oceanicharvest.sg" className="w-full p-2 border border-border-default rounded-fluent text-sm bg-surface-secondary" disabled data-id="element-1939" />
                </div>
                <div data-id="element-1940">
                  <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1941">
                    Phone Number
                  </label>
                  <input type="tel" defaultValue="+65 6234 5678" className="w-full p-2 border border-border-default rounded-fluent text-sm" data-id="element-1942" />
                </div>
                <div data-id="element-1943">
                  <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1944">
                    Job Title
                  </label>
                  <input type="text" defaultValue="Managing Director" className="w-full p-2 border border-border-default rounded-fluent text-sm" data-id="element-1945" />
                </div>
              </div>
              <Button variant="primary" data-id="element-1946">Save Changes</Button>
            </div>}

          {activeTab === 'users' && <div className="space-y-4" data-id="element-1947">
              <div className="flex justify-between items-center" data-id="element-1948">
                <h3 className="text-lg font-semibold text-text-primary" data-id="element-1949">
                  Manage Users
                </h3>
                <Button variant="primary" leftIcon={<PlusIcon className="w-4 h-4" data-id="element-1951" />} data-id="element-1950">
                  Invite User
                </Button>
              </div>
              <DataTable data={users} columns={[{
            header: 'Name',
            accessorKey: 'name',
            cell: row => <span className="font-medium" data-id="element-1953">{row.name}</span>
          }, {
            header: 'Email',
            accessorKey: 'email'
          }, {
            header: 'Role',
            accessorKey: 'role'
          }, {
            header: 'Status',
            cell: row => <StatusPill status={row.status} data-id="element-1954" />
          }, {
            header: 'Last Login',
            accessorKey: 'lastLogin'
          }, {
            header: 'Actions',
            cell: () => <Button variant="ghost" size="sm" data-id="element-1955">
                        Edit
                      </Button>
          }]} data-id="element-1952" />
            </div>}

          {activeTab === 'notifications' && <div className="max-w-2xl space-y-6" data-id="element-1956">
              <h3 className="text-lg font-semibold text-text-primary" data-id="element-1957">
                Notification Preferences
              </h3>
              <div className="space-y-4" data-id="element-1958">
                {[{
              title: 'Order Notifications',
              desc: 'New POs, changes, and cancellations'
            }, {
              title: 'Invoice Updates',
              desc: 'Status changes, exceptions, and payments'
            }, {
              title: 'Contract Alerts',
              desc: 'Expiring contracts, new amendments'
            }, {
              title: 'Compliance & Risk',
              desc: 'Expiring documents, new assessments'
            }, {
              title: 'Quality Incidents',
              desc: 'New cases and CAPA requests'
            }].map((item, idx) => <div key={idx} className="flex items-center justify-between p-4 border border-border-light rounded-fluent bg-surface-secondary" data-id="element-1959">
                    <div data-id="element-1960">
                      <h4 className="font-medium text-text-primary" data-id="element-1961">
                        {item.title}
                      </h4>
                      <p className="text-sm text-text-secondary" data-id="element-1962">{item.desc}</p>
                    </div>
                    <div className="flex gap-4" data-id="element-1963">
                      <label className="flex items-center gap-2 text-sm" data-id="element-1964">
                        <input type="checkbox" defaultChecked className="rounded text-fpg-navy focus:ring-fpg-navy" data-id="element-1965" />{' '}
                        Email
                      </label>
                      <label className="flex items-center gap-2 text-sm" data-id="element-1966">
                        <input type="checkbox" defaultChecked className="rounded text-fpg-navy focus:ring-fpg-navy" data-id="element-1967" />{' '}
                        Portal
                      </label>
                    </div>
                  </div>)}
              </div>
              <Button variant="primary" data-id="element-1968">Save Preferences</Button>
            </div>}

          {activeTab === 'security' && <div className="max-w-2xl space-y-6" data-id="element-1969">
              <h3 className="text-lg font-semibold text-text-primary" data-id="element-1970">
                Security Settings
              </h3>
              <div className="p-4 border border-border-light rounded-fluent flex justify-between items-center" data-id="element-1971">
                <div data-id="element-1972">
                  <h4 className="font-medium text-text-primary flex items-center gap-2" data-id="element-1973">
                    <ShieldIcon className="w-4 h-4 text-status-success" data-id="element-1974" />{' '}
                    Multi-Factor Authentication (MFA)
                  </h4>
                  <p className="text-sm text-text-secondary" data-id="element-1975">
                    Add an extra layer of security to your account.
                  </p>
                </div>
                <StatusPill status="Active" data-id="element-1976" />
              </div>
              <div className="p-4 border border-border-light rounded-fluent" data-id="element-1977">
                <h4 className="font-medium text-text-primary mb-2" data-id="element-1978">
                  Change Password
                </h4>
                <div className="space-y-3 max-w-sm" data-id="element-1979">
                  <input type="password" placeholder="Current Password" className="w-full p-2 border border-border-default rounded-fluent text-sm" data-id="element-1980" />
                  <input type="password" placeholder="New Password" className="w-full p-2 border border-border-default rounded-fluent text-sm" data-id="element-1981" />
                  <input type="password" placeholder="Confirm New Password" className="w-full p-2 border border-border-default rounded-fluent text-sm" data-id="element-1982" />
                  <Button variant="secondary" data-id="element-1983">Update Password</Button>
                </div>
              </div>
            </div>}

          {activeTab === 'preferences' && <div className="max-w-2xl space-y-6" data-id="element-1984">
              <h3 className="text-lg font-semibold text-text-primary" data-id="element-1985">
                Regional Preferences
              </h3>
              <div className="grid grid-cols-2 gap-4" data-id="element-1986">
                <div data-id="element-1987">
                  <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1988">
                    Language
                  </label>
                  <select className="w-full p-2 border border-border-default rounded-fluent text-sm bg-white" data-id="element-1989">
                    <option data-id="element-1990">English (UK)</option>
                    <option data-id="element-1991">English (US)</option>
                    <option data-id="element-1992">Chinese (Simplified)</option>
                  </select>
                </div>
                <div data-id="element-1993">
                  <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1994">
                    Timezone
                  </label>
                  <select className="w-full p-2 border border-border-default rounded-fluent text-sm bg-white" data-id="element-1995">
                    <option data-id="element-1996">Asia/Singapore (UTC+8)</option>
                    <option data-id="element-1997">Australia/Sydney (UTC+10)</option>
                  </select>
                </div>
                <div data-id="element-1998">
                  <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1999">
                    Date Format
                  </label>
                  <select className="w-full p-2 border border-border-default rounded-fluent text-sm bg-white" data-id="element-2000">
                    <option data-id="element-2001">DD/MM/YYYY</option>
                    <option data-id="element-2002">MM/DD/YYYY</option>
                    <option data-id="element-2003">YYYY-MM-DD</option>
                  </select>
                </div>
                <div data-id="element-2004">
                  <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-2005">
                    Currency Display
                  </label>
                  <select className="w-full p-2 border border-border-default rounded-fluent text-sm bg-white" data-id="element-2006">
                    <option data-id="element-2007">SGD ($)</option>
                    <option data-id="element-2008">USD ($)</option>
                  </select>
                </div>
              </div>
              <Button variant="primary" data-id="element-2009">Save Preferences</Button>
            </div>}
        </div>
      </Card>
    </div>;
};